import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`

    .tab-section {
        background: ${colors.bg3};
        padding   : 70px 0 65px;

        .nav {
            background-color: #ffffff;
            border-radius : 5px;
            border  : 1px solid ${colors.border1};
            overflow: hidden;

            .nav-item {
                a.nav-link {
                    font-size    : 15px;
                    color        : ${colors.black1};
                    border-bottom: 1px solid ${colors.border1};
                    padding      : 18px 25px;

                    i {
                        color: ${colors.green};
                    }
                }

                a.nav-link.active {
                    background: ${colors.gr_bg};
                    color     : #ffffff;

                    i {
                        color: #ffffff;
                    }
                }

                &:last-child {
                    a.nav-link {
                        border-bottom: none;
                    }
                }
            }

            @media(max-width: 767px) {
                margin-bottom : 30px;
            }
        }

        .back1
        {
            background: #fff;
    padding: 10px;
        }

        .apply-btn {
            margin-left: 40px;

            a {
                font-size     : 13px;
                color         : #ffffff;
                background    : ${colors.gr_bg};
                display       : inline-block;
                width         : 100%;
                height        : 40px;
                text-align    : center;
                text-transform: uppercase;
                font-weight   : 500;
                padding       : 11px;
                border-radius : 0 5px 5px 0;
                position: relative;

                i {
                    position : absolute;
                    font-size: 20px;
                    left     : -40px;
                    top      : 0;
                    padding  : 10px;
                    width    : 40px;
                    height   : 100%;
                    border-radius : 5px 0 0 5px;
                    background-color: ${colors.green2};
                }

                &:hover {
                    background: ${colors.gr_bg2};
                }
            }
        }

        .tab-content {
            .tab-pane {
                h4.tab-title {
                    color        : ${colors.black1};
                    font-weight  : 600;
                    margin-bottom: 25px;
                    border-bottom: 1px solid #02984a;

                    @media(max-width: 575px) {
                        margin-bottom: 15px;
                        font-size: 20px;
                    }
                }

                p.tab-desc {
                    font-size    : 15px;
                    color        : ${colors.text2};
                    line-height  : 30px;
                    margin-bottom: 25px;
                    text-align: justify;

                    @media(max-width: 575px) {
                        font-size: 14px;
                    }
                }

                ul.check-list {
                    li {
                        font-size    : 15px;
                        color        : ${colors.text3};
                        margin-bottom: 20px;
                        line-height  : 25px;

                        i {
                            float : left;
                            color : ${colors.green};
                            border: 1px solid ${colors.border3};
                            width : 35px;
                            height: 35px;
                            border-radius : 50%;
                            text-align  : center;
                            padding-top : 9px;
                            margin-top  : 7px;
                            margin-right: 15px;
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }

                        @media(max-width: 575px) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }

        @media(max-width: 767px) {
            padding: 35px 0 30px;
        }
        .detail_img
        {
            width:100%
        }
    }
`;